import ApiModel from './globals/ApiModel';

export default class ShowSyncModel extends ApiModel {
  static get path() {
    return '/backend/shows/{?id}/sync';
  }
}
